<p class="subtitle has-text-weight-bold is-size-3">[Current] Weather Chart</p>
<app-image-columns [data]="data"></app-image-columns>